export const LOCAL_STORAGE_LOCALE_KEY = 'ao3Locale'

export const LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY = 'ao3AccessToken'

export const LOCAL_STORAGE_AUTH_REFRESH_TOKEN_KEY = 'ao3RefreshToken'

export const LOCAL_STORAGE_ENTITES_TABLE_SATATE_KEY = 'ao3TableState'

export const LOCAL_STORAGE_ENTITIES_CALENDAR_STATE_KEY = 'ao3CalendarState'

export const LOCAL_STORAGE_LAST_SELECTED_COMPANY_ID = 'ao3LastSelectedCompanyId'

export const LOCAL_STORAGE_APP_HEADER_VARIANT = 'ao3AppHeaderVariant'

export const LOCAL_STORAGE_APP_SIDEBAR_TEMPORARY = 'ao3AppSidebarTemporary'
